import { EAvailableBrokerFlow } from '../../repositories/newbuilding-search/entities/newbuilding_broker/NewbuildingBrokerSchema';
import { IApplicationState } from '../../types/redux';
import { getPageNewbuildingBroker } from './getPageNewbuildingBroker';

export function getIsBrokerBannerAvailable(state: IApplicationState) {
  if (state.config.isBrokerEnabled) {
    const newbuildingBroker = getPageNewbuildingBroker(state);

    return newbuildingBroker?.availableBrokerFlow === EAvailableBrokerFlow.WithPartnerRewards;
  }

  return false;
}
